export default __webpack_public_path__ + "assets/animations/holiday_campaign.riv";